import {FailedLinkStatus} from "@/src/components/OrderAuthModal/model";

export const FAILED_LINK_STATUSES: FailedLinkStatus[] = ["not-found", "expired"]
